export default __webpack_public_path__ + "static/media/c++ icone.8ffc43f7.png";